import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getClients } from 'services/profile-editor';

export default function useClients(
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    ['clients'],
    () =>
      getClients().then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError.message);
        }
        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
